const strings = {
  en: {
    label: 'PRODUCT',
    titlePart1: 'Everything You Need to ',
    titleAccent: 'Optimize Sales Performance',
    subtitle: 'From recording conversations to AI-powered coaching — SAPOT AI provides every tool your sales organization needs to standardize processes and grow revenue.',
    learnMore: 'Learn more →',
    ctaTitle: 'Get started with SAPOT AI.',
    ctaDesc: 'Use SAPOT AI, the sales intelligence platform, to improve every step of the sales performance lifecycle.',
    ctaStart: 'Start building',
    ctaDemo: 'Get a demo',
  },
  zh: {
    label: '产品',
    titlePart1: '您所需的一切,助您',
    titleAccent: '优化销售表现',
    subtitle: '从记录对话到 AI 驱动的辅导 —— SAPOT AI 为您的销售组织提供标准化流程、推动营收增长所需的每一项工具。',
    learnMore: '了解更多 →',
    ctaTitle: '即刻开始使用 SAPOT AI。',
    ctaDesc: '使用销售智能平台 SAPOT AI,全面优化销售表现生命周期的每一个环节。',
    ctaStart: '立即开始',
    ctaDemo: '预约演示',
  },
};

export default strings;
